import { Card, Center, Loader } from '@mantine/core';

import type { WithTestId } from 'types/common';

type LoadingCardProps = WithTestId;

export default function LoadingCard({ 'data-testid': testId }: LoadingCardProps = {}) {
  return (
    <Card data-testid={testId} p="xl">
      <Center>
        <Loader />
      </Center>
    </Card>
  );
}
